import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import Axios from 'axios';
import { showMessage } from 'services/settings/message';

export async function fetchQualityControlItems(id) {
	let QualityControlItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `/sandbox/qcsearchlotno?msearchval=${id}`,
		});

		const { data } = response;
		QualityControlItems = data;
	} catch (e) {
		showMessage(e);
	}

	return QualityControlItems;
}

export async function fetchLevelItems() {
	let levelItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `/sandbox/qclistofvalues?mcategory=level`,
		});

		const { data } = response;
		levelItems = data;
	} catch (e) {
		showMessage(e);
	}
	return levelItems;
}

export async function fetchAnalyzerNameItems() {
	let analyzerNameItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `/sandbox/qclistofvalues?mcategory=analyzer`,
		});

		const { data } = response;
		analyzerNameItems = data;
	} catch (e) {
		showMessage(e);
	}
	return analyzerNameItems;
}

export async function addQualityControlLotNo(payload) {
	let QualityControlLotNo = [];

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `/sandbox/qcaddlotno`,
			data: payload,
		}).then(response => {
			return response;
		});
		// @ts-ignore
		QualityControlLotNo = await response;
	} catch (e) {
		showMessage(e);
	}
	return QualityControlLotNo;
}

export async function addQualityControlDataValue(payload) {
	let qualityControlDataValue = [];

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `/sandbox/qcdatavalues`,
			data: payload,
		}).then(response => {
			return response;
		});

		// @ts-ignore
		qualityControlDataValue = await response;
	} catch (e) {
		showMessage(e);
	}
	return qualityControlDataValue;
}

export async function fetchQualityControlDataList(payload) {
	let generatedReportsList = null;

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `/sandbox/qcdatavalues?manalyteid=${payload.manalyteid}`,
		});

		// @ts-ignore
		generatedReportsList = response;
	} catch (e) {
		showMessage(e);
	}

	return generatedReportsList;
}

export async function fetchGeneratedReportsList(payload) {
	let generatedReportsList = null;

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `/sandbox/qcgenrpt?mlotno=${payload.mlotno}&manalyteid=${payload.manalyteid}`,
		});

		// @ts-ignore
		generatedReportsList = response;
	} catch (e) {
		showMessage(e);
	}

	return generatedReportsList;
}

//1
export async function QualityControlChart(payload) {
	let qualityControlChart = [];

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `/reports/jrprintform/labheroqc/qualitycontrol/QualityControlChart.jrxml`,
			data: payload,
		}).then(response => {
			return response;
		});

		// @ts-ignore
		qualityControlChart = await response;
	} catch (e) {
		showMessage(e);
	}
	return qualityControlChart;
}

//2
export async function fetchGenerateView(payload) {
	let GenerateViewReports = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `/reports/jrprintform/labheroqc/qualitycontrol/QualityControlChart.jrxml?filename=${payload.filename}&filetype=${payload.filetype}`,
		}).then(response => {
			return response;
		});

		// @ts-ignore
		GenerateViewReports = await response;
	} catch (e) {
		showMessage(e);
	}

	return GenerateViewReports;
}

//3
export async function addQualityControlGenerateReport(payload) {
	let qualityControlDataValue = [];

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `/sandbox/qcaddgenrpt`,
			data: payload,
		}).then(response => {
			return response;
		});

		// @ts-ignore
		qualityControlDataValue = await response;
	} catch (e) {
		showMessage(e);
	}
	return qualityControlDataValue;
}

export async function qualityControlChartPrint(payload) {
	let qcChartPrint = [];

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `/reports/jrdirectprint3/labheroqc/qualitycontrol/QualityControlChart.jrxml`,
			data: payload,
		}).then(response => {
			return response;
		});

		// @ts-ignore
		qcChartPrint = await response;
	} catch (e) {
		showMessage(e);
	}
	return qcChartPrint;
}

// export async function createQualityControlItems(payload) {
// 	let QualityControlItems = [];

// 	try {
// 		const response = await axiosLabAPI({
// 			method: API_POST_METHOD,
// 			url: `/lab/LabAnalyzer/Settings`,
// 			data: payload,
// 		}).then(response => {
// 			return response;
// 		});

// 		// @ts-ignore
// 		QualityControlItems = await response;
// 	} catch (e) {
// 		Message.error();
// 	}
// 	return QualityControlItems;
// }

// export async function updateQualityControlItems(payload) {
// 	let QualityControlItems = [];

// 	try {
// 		const content = {
// 			method: API_PUT_METHOD,
// 			url: `/lab/LabAnalyzer/Settings`,
// 			data: payload,
// 		};

// 		const response = await axiosLabAPI(content);
// 		// @ts-ignore
// 		QualityControlItems = await response;
// 	} catch (e) {
// 		Message.error();
// 	}

// 	return QualityControlItems;
// }
